const ACTIONS = [
  { y: 46, label: 'Invoice sent to Northwind' },
  { y: 118, label: 'Deal moved to Won' },
  { y: 190, label: 'Weekly report scheduled', isResolved: true },
  { y: 262, label: 'New lead added to the CRM' },
  { y: 334, label: 'Reply drafted for review' }
];

const CORE = { x: 64, y: 190 };
const NODE_X = 236;

/**
 * One center sending thin paths out to several finished actions: the brand's "one intelligence,
 * many actions". The coral node is the one that just resolved, echoing the wordmark's dot.
 */
const ConnectedActionsIllustration = () => {
  return (
    <svg className="auth-illustration" viewBox="0 0 480 380" role="presentation">
      {ACTIONS.map((action) => (
        <path key={action.label} className="auth-illustration__path" d={`M ${CORE.x} ${CORE.y} C ${CORE.x + 92} ${CORE.y}, ${NODE_X - 96} ${action.y}, ${NODE_X} ${action.y}`} pathLength="1" />
      ))}
      <circle className="auth-illustration__core-ring" cx={CORE.x} cy={CORE.y} r="22" />
      <circle className="auth-illustration__core" cx={CORE.x} cy={CORE.y} r="9" />
      {ACTIONS.map((action) => (
        <g key={`${action.label}-node`} className="auth-illustration__action">
          <circle className={action.isResolved ? 'auth-illustration__node auth-illustration__node--resolved' : 'auth-illustration__node'} cx={NODE_X} cy={action.y} r="5" />
          <text className="auth-illustration__label" x={NODE_X + 18} y={action.y + 4}>
            {action.label}
          </text>
        </g>
      ))}
    </svg>
  );
};

export default ConnectedActionsIllustration;
